import React, {Fragment, useEffect, useState} from 'react';
import i18n from 'i18next';
import { Link, useForm } from '@inertiajs/inertia-react';
import '@inertiajs/inertia-react';
import Button from '@/Components/Button';
import { FormInput, PhoneOrEmailInput } from "@/Components/Controls";
import '../../../sass/authenticated/profile-settings-slider.scss';
import '@/../sass/authenticated/slider.scss';

export default function LoginSettingsSlider({show, props, toggleLoginSettings, toggleMyProfile}) {
    const { data, setData, post, processing, errors } = useForm({
        first_name: props.auth.user.first_name,
        last_name: props.auth.user.last_name,
        email: props.auth.user.email,
        phone: props.auth.user.phone
    });

    const canSelfEdit = props.auth.user.can.canSelfEdit;

    const [formDataModified, setFormDataModified] = useState(false);
    const [successMessageVisible, setSuccessMessageVisible] = useState(false);
    const [failedMessageVisible, setFailedMessageVisible] = useState(false);

    const onChange = (event, value) => {
        setData(event, value);
    };

    useEffect(() => {
        const phone = props.auth.user.phone;
        const formattedCurrentPhone = phone ? phone.replace(/\D/g, '') : '';
        const formattedInputPhone = data.phone ? data.phone.replace(/\D/g, '') : '';
        if (data.email !== props.auth.user.email || formattedInputPhone !== formattedCurrentPhone) {
            setFormDataModified(true);
        }
        else {
            setFormDataModified(false);
        }
    }, [data]);

    useEffect(() => {
        if (!show) {
            if (successMessageVisible) {
                setSuccessMessageVisible(false);
            }
            else if (failedMessageVisible) {
                setFailedMessageVisible(false);
            }
        }
    }, [show]);

    const successMessageDisplay = (display) => {
        setSuccessMessageVisible(display);
    }

    const failedMessageDisplay = (display) => {
        setFailedMessageVisible(display);
    }

    const redirectToMyProfileSlider = () => {
        toggleLoginSettings();
        toggleMyProfile();
    }

    const save = (e) => {
        e.preventDefault();

        post(route('manage.profile.store'), {
            onSuccess: () => toggleLoginSettings(),
        });
    };

    return (
        <Fragment>
            {show && <div className={"fade modal-backdrop slider-backdrop show"} />}
            <div className={show ? "profile-settings-slider show" : "profile-settings-slider"} data-testid="profile-settings-slider-login_settings">
                <div className='slider-div'>
                    <div className="profile-div">
                        <div className="header-div">
                            <Button type="button" className="back-button buttons"
                                    onClick={() => toggleLoginSettings()}>
                                <div className="back-button-content">
                                    <div className="back-button-content-chevron-left-div">
                                        <i className="fas fa-chevron-left back-button-content-chevron-left"></i>
                                    </div>
                                    <div className="back-button-text">
                                        {i18n.t("login-settings-slider.back")}
                                    </div>
                                </div>
                            </Button>
                            <div className="title">{i18n.t("login-settings-slider.title")}</div>
                            <div className="header-right-div"></div>
                        </div>
                        <img className="fill" src="/images/userprofile-slider-gradient.svg"/>
                    </div>
                    <div className="profile-info-div">
                        <div className="profile-info-form-div">
                            <div className="profile-info-header">
                                {i18n.t("login-settings-slider.form-header")}
                            </div>
                            <form className="profile-form">
                                <FormInput
                                    error={errors["email"]} name="email"
                                    isFocused={true} autoComplete="email" value={data.email}
                                    onChange={onChange} label={i18n.t("login-settings-slider.login-email")}
                                    className="form-input"
                                    dataTestid="login_settings_slider-input-login_email" disabled={!canSelfEdit}
                                />
                                <PhoneOrEmailInput
                                    error={errors["phone"]} name="phone" isFocused={true}
                                    autoComplete="phone" value={data.phone} onChange={onChange} label={i18n.t("login-settings-slider.login-phone")}
                                    className="form-input"
                                    dataTestid="login_settings_slider-input-login-phone" disabled={!canSelfEdit}
                                />
                            </form>
                        </div>
                    </div>
                    <div className="change-login-email-div">
                        <span id="changing-login-email-header-text">{i18n.t("login-settings-slider.changing-login-email.header")}</span>
                        <br/>
                        <span
                            id="changing-login-email-text">{i18n.t("login-settings-slider.changing-login-email.your-login-email")}{" "}
                            <span id="login-email-text">({props.auth.user.email})</span>
                            {" "}{i18n.t("login-settings-slider.changing-login-email.can-no-longer-be-used")}
                            <br/><br/>
                            {i18n.t("login-settings-slider.changing-login-email.contact-email-wont-change")}
                            <br/>
                            {i18n.t("login-settings-slider.changing-login-email.want-to-change-contact-email")}{" "}
                            <Button data-testid={'login_settings_slider-my_profile_link'}
                                    className="my-profile-link"
                                    onClick={() => redirectToMyProfileSlider()}>
                                    {i18n.t("login-settings-slider.changing-login-email.my-profile-link")}
                            </Button>
                        </span>
                    </div>
                    <div className="actions-footer">
                        <Link
                            href={route('manage.profile.destroy')}
                            className="request-account-deletion-button buttons"
                            method="delete"
                            as="button"
                            onFinish={() => {
                                location.reload();
                            }}
                        >
                            {i18n.t("login-settings-slider.request-account-deletion")}
                        </Link>
                        <div className="actions-footer-right-buttons-div">
                            <Button type="button" className="cancel-button buttons"
                                    onClick={() => toggleLoginSettings()} value="Cancel">
                                {i18n.t("login-settings-slider.cancel")}
                            </Button>
                            <Button className={`save-button${!formDataModified ? "-disabled" : ""} buttons`}
                                    processing={processing} onClick={save}>
                                {i18n.t("login-settings-slider.save")}
                            </Button>
                        </div>
                    </div>
                </div>
                <div
                    className={`update-message${successMessageVisible ? "-active update-success-message" : "-hidden"}`}>
                    <div className="update-success-message-checkbox-div update-message-symbol-div">
                        <i className="fas fa-check"></i>
                    </div>
                    <div className="update-message-text-div">
                        {i18n.t("login-settings-slider.update-message.success")}
                    </div>
                    <div className="update-message-close-div">
                        <Button type="button"
                                className="update-success-message-close-button update-message-close-button"
                                onClick={() => successMessageDisplay(false)}>
                            <i className="fas fa-times"></i>
                        </Button>
                    </div>
                </div>
                <div
                    className={`update-message${failedMessageVisible ? "-active update-failed-message" : "-hidden"}`}>
                    <div className="update-failed-message-exclamationtriangle-div update-message-symbol-div">
                        <i className="fas fa-exclamation-triangle"></i>
                    </div>
                    <div className="update-message-text-div">
                        {i18n.t("login-settings-slider.update-message.error")}
                    </div>
                    <div className="update-message-close-div">
                        <Button type="button"
                                className="update-failed-message-close-button update-message-close-button"
                                onClick={() => failedMessageDisplay(false)}>
                            <i className="fas fa-times"></i>
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
